import React, { FC } from 'react';
import { Text, RichText, Placeholder, ComponentRendering } from '@sitecore-jss/sitecore-jss-react';
import useMediaQuery from '../../../../hooks/useMediaQuery';
import { BreakpointsInPx } from '../../../../constants/breakpoints.constants';
import { InteractiveImageProps } from '../../types/interactiveImage.types';
import { InteractiveImageModel } from '../../models/interactiveImage.model';
import CTA from '../../../@shared/CTA';
import ctaTypes from '../../../../enums/CTA.enums';
import { findCtaType } from '../../../../utils/popUpCtaType.utils';
import { targetLinkdsk } from '../../../../utils/targetDskLink';
import WrapFade from './wrapFade';
import './styles.scss';

const InteractiveImageText: FC<InteractiveImageProps & { isEE: boolean }> = (props) => {
  const model = new InteractiveImageModel(props);
  const isDesktop = useMediaQuery(`(min-width: ${BreakpointsInPx['tbl-p']})`);

  const popUpCtaType = findCtaType(props.rendering);

  return (
    <div className="interactive-image-text-wrapper">
      <WrapFade isDesktop={isDesktop} isEE={props.isEE} duration={1000} delay={2000}>
        <div className="interactive-image-text">
          {model.eyebrow && <Text field={model.eyebrow} tag="div" className="interactive-image-text__eyebrow" />}
          {model.title && <Text field={model.title} tag="div" className="interactive-image-text__title" />}
          {model.description && <RichText field={model.description} tag="div" className="interactive-image-text__description rich-text" />}
          <div className="interactive-image-text__link-wrapper">
            {(props.isEE || (model.primaryLink?.value?.text && model.primaryLink?.value?.href)) && (
              <CTA
                field={model.primaryLink}
                target={targetLinkdsk(model?.primaryLink, isDesktop)}
                type={ctaTypes.primaryOrange}
                extraClassName={popUpCtaType}
              />
            )}
            <div className="interactive-image-text__pop-up">
              <Placeholder name={'jss-generic-popup'} rendering={props.rendering as ComponentRendering} />
            </div>
          </div>
        </div>
      </WrapFade>
    </div>
  );
};

export default InteractiveImageText;
